export default __webpack_public_path__ + "static/media/welcome-icon.c192eecb.png";